export default __webpack_public_path__ + "static/media/One.cf74c035.svg";